/** Décennie d'une année (ex. 1987 → 1980). */
export function releaseYearToDecade(year) {
    return Math.floor(year / 10) * 10;
}
/** Libellé affiché pour une décennie (ex. « années 1980 »). */
export function formatDecadeLabel(decade) {
    return `années ${decade}`;
}
